

import { useState, useCallback } from 'react';

const useToast = () => {
  const [toastMessage, setToastMessage] = useState('');

  const showToastMessage = useCallback((message) => {
    setToastMessage(message);
  }, []);

  const hideToast = useCallback(() => {
    setToastMessage('');
  }, []);

  return { toastMessage, showToastMessage, hideToast };
};

export default useToast;

